import Moment from "moment";
import BaseEntity from "./base.entity";

import { fn } from "util";

export default class Customer extends BaseEntity {
  constructor(params) {
    super(params);

    if (params && params.birth_date) {
      if (params.raw_birth_date) {
        this.birth_date = new Moment(this.raw_birth_date).format("DD/MM/YYYY");
      } else {
        this.raw_birth_date = params.birth_date;
        this.birth_date = new Moment(params.birth_date).format("DD/MM/YYYY");
      }
    }
  }

  defaultParams() {
    return {
      name: "",
      identification: "",
      notes: "",
      address: {
        state: "",
        zipcode: "",
        city: "",
        neighborhood: "",
        street: "",
        number: "",
        complement: ""
      },
      custom_fields: {},
      phone: null,
      email: null,
      birth_date: null,
      deleted: false
    };
  }

  identifier(defaultIdentifier = "Não identificado") {
    return this.name || this.identification || this.email || defaultIdentifier;
  }

  setZipcode(value) {
    this.address.zipcode = !!value ? value.replace(/\D/g, "") : "";
  }

  setPhone(value) {
    this.phone = !!value ? value.replace(/[()_-\s]/g, "") : null;
  }

  getServiceObject() {
    let birthDate = null;

    if (this.birth_date) {
      const momentBirthDate = new Moment(this.birth_date, "DD/MM/YYYY");

      if (momentBirthDate.isValid()) {
        this.raw_birth_date = momentBirthDate.toISOString();
        birthDate = this.raw_birth_date;
      }
    }

    return {
      name: this.name,
      email: this.email,
      identification: this.identification,
      phone: this.phone,
      notes: this.notes,
      address: {
        city: this.address.city,
        state: this.address.state,
        zipcode: this.address.zipcode,
        neighborhood: this.address.neighborhood,
        street: this.address.street,
        number: this.address.number,
        complement: this.address.complement
      },
      custom_fields: this.custom_fields,
      birth_date: birthDate,
      deleted: this.deleted
    };
  }

  getAddress() {
    const itens = [];
    const address = this.address;

    if (!fn.isBlank(address)) {
      if (!fn.isBlank(address.street)) {
        itens.push(address.street);

        if (!fn.isBlank(address.number)) {
          itens.push(address.number);
        }
      }

      if (!fn.isBlank(address.city)) {
        if (!fn.isBlank(address.state)) {
          itens.push(`${address.city} - ${address.state}`);
        } else {
          itens.push(address.city);
        }
      }

      if (!fn.isBlank(address.complement)) {
        itens.push(`Complemento: ${address.complement}`);
      }

      if (!fn.isBlank(address.zipcode)) {
        itens.push(`CEP: ${address.zipcode}`);
      }

      return itens.join(", ");
    }
  }

  getCustomFields(fieldConfig) {
    const items = [];
    const customFields = Object.entries(this.custom_fields || {});

    customFields.forEach(([key, value]) => {
      if (fieldConfig.length !== 0) {
        const config = fieldConfig.find(field => field.uuid === key);

        if (!fn.isBlank(value)) {
          if (config.type === "date") {
            items.push(
              `${config.name}: ${Moment(value, "YYYY/MM/DD").format(
                "DD/MM/YYYY"
              )}`
            );
          } else if (config.type === "datetime") {
            items.push(
              `${config.name}: ${Moment(value, "YYYY/MM/DD hh:mm").format(
                "DD/MM/YYYY HH:mm"
              )}`
            );
          } else if (config.type === "hour") {
            items.push(
              `${config.name}: ${Moment(value, "YYYY/MM/DD hh:mm").format(
                "HH:mm"
              )}`
            );
          } else {
            items.push(`${config.name}: ${value}`);
          }
        }
      }
    });

    return items.join(", ");
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/customer.entity.js